import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterSubdistrictList = () => {
  const subdistrictList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-subdistrict/list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { subdistrictList }
}

export default InteractorMasterSubdistrictList
